export default "__VITE_ASSET__8648b5c7__"